import { formatISO, isValid } from 'date-fns';

export const mapToIsoOnlyDate = (date: Date | null | undefined): Date | null => {
	return isValid(date) && date ? (formatISO(date, { representation: 'date' }) as any) : null;
};
